import { useLanguage, t } from "../../../i18n";
import React from "react";
import { Button } from "react-bootstrap";
import "./SectionHeader.css";
export default function SectionHeader({
  title,
  subtitle,
  actionLabel,
  onActionClick
}) {
  useLanguage();
  return <div className="bb-section-header">
      <div className="bb-section-header__content">
        <div className="bb-section-header__title">{t(title)}</div>
        {subtitle ? <p className="bb-section-header__subtitle">{t(subtitle)}</p> : null}
      </div>

      {actionLabel ? <Button className="bb-brand-btn-outline" variant="outline-primary" onClick={onActionClick}>
          {t(actionLabel)}
        </Button> : null}
    </div>;
}
